import { theme } from '../../../tailwind.config'

export default {
  data() {
    return {
      screenSize: {
        width: window.outerWidth,
        height: window.outerHeight,
      },
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateScreenSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenSize)
  },
  methods: {
    updateScreenSize() {
      this.screenSize.width = window.outerWidth
      this.screenSize.height = window.outerHeight
    },
  },
  computed: {
    isMobileScreenSize() {
      return this.screenSize.width <= parseInt(theme.screens.sm, 10)
    },
  },
}
